import store from '../index.js'
import { $getUrlParam }  from "@/common/common.js"
const state = {
  initTrack: false,
  initUser: false
}

const mutations = {
  INIT_SEPT_TRACK: (state, params) => {
    // 初始化埋点
    if (!state.initTrack && septTrack) {
      septTrack('init', '7bb9beca-27ca-4b7d-9005-ee415cbec53c', { clck: false })
      state.initTrack = true
    }
  },
  INIT_TRACK_USER: (state, params) => {
    // 初始化用户信息
    if (!state.initUser && store.state.userInfo && septTrack) {
      septTrack('setUserId', store.state.userInfo.userCode)
      state.initUser = true
    }
  },
  SEPT_TRACK: (state, params) => {
    let trackName = params.name
    delete params.name
    let trackParams = params
    let query = $getUrlParam()
    // 移除不必要的参数
    delete query.payCode
    // 合并埋点参数和url上的参数
    trackParams = Object.assign(trackParams, query)
    if (septTrack) septTrack('track', 'h5_official_' + trackName, trackParams)
  }
}

const actions = {
  // 埋点操作
  septTrack({ commit }, params) {
    // 初始化埋点
    commit('INIT_SEPT_TRACK')
    // 初始化埋点用户
    commit('INIT_TRACK_USER', params)
    // 记录埋点
    commit('SEPT_TRACK', params)
  }
}


export default {
  namespaced: true,
  state,
  mutations,
  actions
}
